module.exports = __webpack_public_path__ + "static/media/spinner-200px.10ec7041.svg";